import { render, staticRenderFns } from "./detailedData.vue?vue&type=template&id=7e2c995e&scoped=true"
import script from "./detailedData.vue?vue&type=script&lang=js"
export * from "./detailedData.vue?vue&type=script&lang=js"
import style0 from "./detailedData.vue?vue&type=style&index=0&id=7e2c995e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c995e",
  null
  
)

export default component.exports